import { z } from "zod";
import { userRightScopeEnumSchema } from "./enumSchemas";
import UserRightScopeEnum from "../../../enums/UserRightScopeEnum";

export const getCurrentUserSchema = z.object({
    auth0Id: z.string()
});